import { io } from 'socket.io-client';
import { updateTask } from '../store/taskSlice';
import { notification } from 'antd';

let socket = null;
let notificationCallback = null;

// Получаем базовый URL для WebSocket
const getSocketUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://92.63.106.142:4000';
  }
  return window.location.origin;
};

export const initSocket = () => {
  if (!socket) {
    const accessToken = localStorage.getItem('accessToken');
    
    socket = io(getSocketUrl(), {
      path: '/socket.io',
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      auth: {
        token: accessToken,
      },
      transports: ['websocket', 'polling'],
    });
    
    socket.on('connect', () => {
      console.log('Socket connected');
      // Подписываемся на все задачи пользователя
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user.id) {
        socket.emit('join_user', user.id);
      }
    });

    // Обработка аутентификации (автоматическая подписка на уведомления)
    socket.on('authenticated', () => {
      console.log('Socket authenticated - automatically subscribed to notifications');
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user.id) {
        // Можно явно подписаться, хотя это должно происходить автоматически
        socket.emit('join_notifications', user.id);
      }
    });

    // Подтверждение подписки на уведомления
    socket.on('notifications_joined', (data) => {
      console.log('Subscribed to notifications:', data);
    });

    // Получение уведомлений
    socket.on('notification', (data) => {
      console.log('New notification received:', data);
      handleNotification(data);
      
      // Если это уведомление о новом сообщении, обновляем счетчик
      if (data.metadata && data.metadata.messageId) {
        // Можно вызвать callback для обновления UI
        if (notificationCallback) {
          notificationCallback({ ...data, type: 'message' });
        }
      }
    });
    
    socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });
    
    socket.on('error', (err) => {
      console.error('Socket error:', err);
    });

    socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });
  }
  return socket;
};

export const connectSocket = () => {
  if (socket && !socket.connected) {
    socket.connect();
  }
};

export const disconnectSocket = () => {
  if (socket && socket.connected) {
    socket.disconnect();
  }
};

export const registerForTask = (taskId) => {
  if (socket && socket.connected) {
    socket.emit('join_task', taskId);
  }
};

export const leaveTask = (taskId) => {
  if (socket && socket.connected) {
    socket.emit('leave_task', taskId);
  }
};

export const listenForUpdates = (dispatch) => {
  if (socket) {
    socket.on('task_update', (data) => {
      console.log('Task update received:', data);
      
      // Определяем структуру данных
      // Может быть: { task: { status, result, ... }, timestamp } или { status, result, ... }
      let taskData = data.task || data;
      let status = taskData.status || data.status;
      // completed_with_warnings from Flask is a success for the client
      if (status === 'completed_with_warnings') {
        status = 'completed';
      }
      let result = taskData.result || data.result || data.data || {};
      let error = taskData.error || data.error;
      
      // Если данные находятся на верхнем уровне task объекта
      if (taskData && !result.download_url) {
        // Извлекаем данные из task объекта
        result = {
          download_url: taskData.result?.download_url || taskData.download_url,
          mhtml_view_url: taskData.result?.mhtml_view_url || taskData.mhtml_view_url,
          mhtml_download_url: taskData.result?.mhtml_download_url || taskData.mhtml_download_url,
          screenshot_url: taskData.result?.screenshot_url || taskData.screenshot_url,
          screenshots_list_url: taskData.result?.screenshots_list_url || taskData.screenshots_list_url,
          mhtml_warnings: taskData.result?.mhtml_warnings || taskData.mhtml_warnings,
          mhtml_error: taskData.result?.mhtml_error || taskData.mhtml_error,
          task_id: taskData.task_id || taskData.id,
          protocol_number: taskData.protocol_number,
          protocol_date: taskData.protocol_date,
          ...result
        };
      }
      
      // Если данные находятся на верхнем уровне (старый формат)
      if (!result.download_url && data.download_url) {
        result = {
          download_url: data.download_url,
          mhtml_view_url: data.mhtml_view_url,
          mhtml_download_url: data.mhtml_download_url,
          screenshot_url: data.screenshot_url,
          screenshots_list_url: data.screenshots_list_url,
          task_id: data.task_id || data.id,
          protocol_number: data.protocol_number,
          protocol_date: data.protocol_date,
          ...result
        };
      }
      
      console.log('Dispatching updateTask with:', { status, result, error });
      
      dispatch(updateTask({
        status: status,
        result: result,
        error: error,
      }));
    });
  }
};

export const removeListeners = () => {
  if (socket) {
    socket.off('task_update');
  }
};

export const updateSocketAuth = (accessToken) => {
  if (socket) {
    socket.auth = { token: accessToken };
    if (socket.connected) {
      socket.disconnect();
      socket.connect();
    }
  }
};

// Обработка уведомления
const handleNotification = (notificationData) => {
  const { type, title, message: msg } = notificationData;
  
  // Определяем тип уведомления для antd
  let notificationType = 'info';
  if (type === 'success') notificationType = 'success';
  else if (type === 'warning') notificationType = 'warning';
  else if (type === 'error') notificationType = 'error';
  
  // Показываем уведомление через antd
  notification[notificationType]({
    message: title || 'Уведомление',
    description: msg || '',
    duration: type === 'error' ? 0 : 4.5, // Ошибки не закрываются автоматически
    placement: 'topRight',
    style: {
      marginTop: '20px',
    },
  });
  
  // Вызываем callback, если он установлен
  if (notificationCallback) {
    notificationCallback(notificationData);
  }
};

// Установить callback для обработки уведомлений
export const setNotificationCallback = (callback) => {
  notificationCallback = callback;
};

// Подписаться на уведомления вручную (опционально)
export const joinNotifications = (userId) => {
  if (socket && socket.connected) {
    socket.emit('join_notifications', userId);
  }
};

// Отписаться от уведомлений
export const leaveNotifications = (userId) => {
  if (socket && socket.connected) {
    socket.emit('leave_notifications', userId);
  }
};

// Подписаться на мониторинг системы (только для админов)
export const joinMonitoring = () => {
  if (socket && socket.connected) {
    socket.emit('join_monitoring');
  }
};

// Отписаться от мониторинга системы
export const leaveMonitoring = () => {
  if (socket && socket.connected) {
    socket.emit('leave_monitoring');
  }
};

// Получить экземпляр сокета для подписки на события
export const getSocket = () => {
  return socket;
};

